import type { MethodOptions, MethodQueryOptions } from "openapi-react-query"

import { $rqBoardsApiClient } from "@/api/boards"

export function getBoardsQueryOptions(
  options?: MethodOptions<typeof $rqBoardsApiClient, "get", "/v1/boards">,
  rqOptions?: MethodQueryOptions<typeof $rqBoardsApiClient, "get", "/v1/boards">
) {
  return $rqBoardsApiClient.queryOptions("get", "/v1/boards", options, {
    staleTime: Infinity,
    ...rqOptions
  })
}
